/**
 * Subscription holds one page: the billing page carries the plan summary,
 * usage meters, and the in-app payment lanes (packages, QR, Khalti) all on
 * `billing_settings_index`.
 */
export default ({ t, accountScopedRoute }) => ({
  name: 'Settings Subscription',
  label: t('SIDEBAR.SUBSCRIPTION'),
  icon: 'i-ph-credit-card',
  defaultFolded: true,
  children: [
    {
      name: 'Settings Billing',
      label: t('SIDEBAR.BILLING'),
      icon: 'i-ph-receipt',
      to: accountScopedRoute('billing_settings_index'),
    },
  ],
});
